import { Select } from 'antd'
import React from 'react'
import { useSelector } from 'react-redux'
import { useMediaQuery } from 'react-responsive'
import { translate } from '../../languages'
import { RootState } from '../../stores'

type Option = {
  value: string
  name: string
}

type ColumnSelectHeaderProps = {
  titleKey: string
  values: number[] | string[]
  onChange: (e: number[] | string[]) => void
  options: Option[]
}

export const ColumnSelectHeader: React.FC<ColumnSelectHeaderProps> = ({
  titleKey,
  values,
  onChange,
  options,
}) => {
  const { language } = useSelector((state: RootState) => state.language)

  const isDesktopScreen = useMediaQuery({ minWidth: '1300px' })

  return (
    <>
      <span>{translate(titleKey, language)}</span>
      {isDesktopScreen && (
        <Select
          mode="multiple"
          maxTagCount="responsive"
          value={values}
          style={{
            width: '100%',
            marginTop: '5px',
          }}
          onChange={(e) => onChange(e)}
        >
          {options.map((item) => (
            <Select.Option value={item.value} key={item.value}>
              {item.name}
            </Select.Option>
          ))}
        </Select>
      )}
    </>
  )
}
